import logger from 'nandos-dev-logger'

function generateWarning (child, parent) {
  return () => logger.warn('Nandos Core-UI', `${child} component used outside of a ${parent}`)
}

export function inject (namespace, child, parent, warn = true) {
  const defaultImpl = child && parent ? {
    register: warn ? generateWarning(child, parent, warn) : () => {},
    unregister: warn ? generateWarning(child, parent, warn) : () => {}
  } : null

  return {
    name: 'registrable-inject',

    inject: {
      [namespace]: {
        default: defaultImpl
      }
    }
  }
}

export function provide (namespace) {
  return {
    name: 'registrable-provide',

    methods: {
      register: null,
      unregister: null
    },
    
    provide() {
      return ({
        [namespace]: {
          register: this.register,
          unregister: this.unregister
        }
      })
    }
  }
}